import React, { useState, useEffect } from "react";
import "./Portfolio.css";
import { connect } from "react-redux";

const Portfolio = (props) => {
  const { formData, onEdit, educations, experiences, skills, interests, awards, projects, certifications, languages } = props;
  const { Name, Thumbnail, Description, URL, City, State, Address, Phone, Email, Facebook, Instagram, Twitter, LinkedIn } = formData;
  console.log("Portfolio Props: ", props);
  const [activeTab, setActiveTab] = useState("education");
  const [perview, setPreview] = useState(false);

  const downloadPortfolio = () => {
    setPreview(true);
    const portfolioElement = document.getElementById("portfolio");
    if (!portfolioElement) {
      console.error("Portfolio element not found!");
      return;
    }

    const file = new Blob([portfolioElement.innerText], { type: "text/plain" });
    const element = document.createElement("a");
    element.href = window.URL.createObjectURL(file);
    element.download = "portfolio.txt"; // Change to .txt for plain text
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  const setPreviewHandler = () => {

    if(perview){
      onEdit();
      return;
    }

    setPreview(!perview);
  }
  


  return (
    <div style={{ marginTop: '50px' }}>
      <div style={{ display: "flex", justifyContent: "end", marginLeft: "300px", width: '75%', gap: '5px' }}>
        <button onClick={setPreviewHandler}>
          {perview ? "Edit" : "Preview"}
        </button>
        <button onClick={downloadPortfolio}>Download</button>
      </div>
      <div className="portfolio" id="portfolio">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
            <div>
              {
                Thumbnail ? <img src={Thumbnail} alt="Thumbnail" className="portfolio-thumbnail" style={{ margin: '0' }} /> : <img src="https://picsum.photos/200/300" style={{ margin: '0' }} alt="Thumbnail" className="portfolio-thumbnail" />
              }
            </div>
            <div style={{ marginLeft: '15px' }}>
              <h1 style={{ textAlign: 'left', marginBottom: 0 }}>{`${Name}`}</h1>
              <p style={{ margin: 0 }}>{Email}</p>
              <p style={{ margin: 0 }}>{City}, {State}</p>
              <p style={{ margin: 0 }}>{Phone}</p>
            </div>
          </div>
          <div>
            <ul style={{ margin: 0, padding: 0, display: 'flex', alignItems: 'center', gap: 15 }}>
              {
                LinkedIn && <li>
                  <a href={LinkedIn} target="_blank" style={{ color: 'gray' }} rel="noopener noreferrer">
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-linkedin" viewBox="0 0 16 16">
                      <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z" />
                    </svg>
                  </a>
                </li>
              }
              {
                Facebook && <li>
                  <a href={Facebook} target="_blank" style={{ color: 'gray' }} rel="noopener noreferrer">
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-facebook" viewBox="0 0 16 16">
                      <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951" />
                    </svg>
                  </a>
                </li>
              }
              {/* insta */}
              {
                Instagram && <li>
                  <a href={Instagram} target="_blank" style={{ color: 'gray' }} rel="noopener noreferrer">
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-instagram" viewBox="0 0 16 16">
                      <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" />
                    </svg>
                  </a>
                </li>
              }
              {
                URL && <li>
                  <a href={URL} style={{ color: 'gray' }} rel="noopener noreferrer" target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-link-45deg" viewBox="0 0 16 16">
                      <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z" />
                      <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z" />
                    </svg>
                  </a>
                </li>
              }
              {
                Twitter && <li>
                  <a href={Twitter} target="_blank" style={{ color: 'gray' }} rel="noopener noreferrer">
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-twitter" viewBox="0 0 16 16">
                      <path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334q.002-.211-.006-.422A6.7 6.7 0 0 0 16 3.542a6.7 6.7 0 0 1-1.889.518 3.3 3.3 0 0 0 1.447-1.817 6.5 6.5 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.32 9.32 0 0 1-6.767-3.429 3.29 3.29 0 0 0 1.018 4.382A3.3 3.3 0 0 1 .64 6.575v.045a3.29 3.29 0 0 0 2.632 3.218 3.2 3.2 0 0 1-.865.115 3 3 0 0 1-.614-.057 3.28 3.28 0 0 0 3.067 2.277A6.6 6.6 0 0 1 .78 13.58a6 6 0 0 1-.78-.045A9.34 9.34 0 0 0 5.026 15" />
                    </svg>
                  </a>
                </li>
              }
            </ul>
          </div>
        </div>
        <p className="portfolio-item">{Description}</p>
        {
          !perview && <div className="portfolio-navbar">
            <ul>
              <li>
                <a href="#education"
                  className={activeTab === "education" ? "active" : ""} onClick={() => setActiveTab("education")}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-mortarboard-fill" viewBox="0 0 16 16">
                    <path d="M8.211 2.047a.5.5 0 0 0-.422 0l-7.5 3.5a.5.5 0 0 0 .025.917l7.5 3a.5.5 0 0 0 .372 0L14 7.14V13a1 1 0 0 0-1 1v2h3v-2a1 1 0 0 0-1-1V6.739l.686-.275a.5.5 0 0 0 .025-.917z" />
                    <path d="M4.176 9.032a.5.5 0 0 0-.656.327l-.5 1.7a.5.5 0 0 0 .294.605l4.5 1.8a.5.5 0 0 0 .372 0l4.5-1.8a.5.5 0 0 0 .294-.605l-.5-1.7a.5.5 0 0 0-.656-.327L8 10.466z" />
                  </svg>
                  <span style={{ marginLeft: '5px' }}>Education</span>
                </a>
              </li>
              <li onClick={() => setActiveTab("experience")}>
                <a href="#experience" className={activeTab === "experience" ? "active" : ""}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-vcard" viewBox="0 0 16 16">
                    <path d="M5 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m4-2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5M9 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4A.5.5 0 0 1 9 8m1 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5" />
                    <path d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM1 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8.96q.04-.245.04-.5C9 10.567 7.21 9 5 9c-2.086 0-3.8 1.398-3.984 3.181A1 1 0 0 1 1 12z" />
                  </svg>
                  <span style={{ marginLeft: '5px' }}>Experience</span>
                </a>
              </li>
              <li onClick={() => setActiveTab("projects")}>
                <a href="#projects" className={activeTab === "projects" ? "active" : ""}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-kanban" viewBox="0 0 16 16">
                    <path d="M13.5 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zm-11-1a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
                    <path d="M6.5 3a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1zm-4 0a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1zm8 0a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1z" />
                  </svg>
                  <span style={{ marginLeft: '5px' }}>Projects</span>
                </a>
              </li>
              <li onClick={() => setActiveTab('certifications')}><a href="#certifications"
                className={activeTab === "certifications" ? "active" : ""}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-award-fill" viewBox="0 0 16 16">
                  <path d="m8 0 1.669.864 1.858.282.842 1.68 1.337 1.32L13.4 6l.306 1.854-1.337 1.32-.842 1.68-1.858.282L8 12l-1.669-.864-1.858-.282-.842-1.68-1.337-1.32L2.6 6l-.306-1.854 1.337-1.32.842-1.68L6.331.864z" />
                  <path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1z" />
                </svg>
                <span style={{ marginLeft: '5px' }}>Certifications</span>
              </a>
              </li>
              <li onClick={() => setActiveTab("skills")}>
                <a href="#skills" className={activeTab === "skills" ? "active" : ""}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lightbulb-fill" viewBox="0 0 16 16">
                    <path d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.46-.302l-.761-1.77a2 2 0 0 0-.453-.618A5.98 5.98 0 0 1 2 6m3 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1-.5-.5" />
                  </svg>
                  <span style={{ marginLeft: '5px' }}>Skills</span>
                </a>
              </li>
              <li onClick={() => setActiveTab("awards")}>
                <a href="#awards" className={activeTab === "awards" ? "active" : ""}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-award-fill" viewBox="0 0 16 16">
                    <path d="m8 0 1.669.864 1.858.282.842 1.68 1.337 1.32L13.4 6l.306 1.854-1.337 1.32-.842 1.68-1.858.282L8 12l-1.669-.864-1.858-.282-.842-1.68-1.337-1.32L2.6 6l-.306-1.854 1.337-1.32.842-1.68L6.331.864z" />
                    <path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1z" />
                  </svg>
                  <span style={{ marginLeft: '5px' }}>Awards</span>
                </a>
              </li>
              <li onClick={() => setActiveTab("interests")}><a href="#interests"
                className={activeTab === "interests" ? "active" : ""}>Interests</a></li>
            </ul>
          </div>
        }
        {
          (perview || activeTab === "education") && educations && (
            <div className="portfolio-section" style={{ marginBottom: 0 }} >
              {
                perview && <h3 style={{ textAlign: 'left', marginBottom: '10px', paddingTop: '15px' }}>Education</h3>
              }
              {educations && educations.map((education, index) => (
                <div style={{ display: 'flex', gap: 15 }} key={index}>
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" fill="currentColor" class="bi bi-mortarboard-fill" viewBox="0 0 16 16">
                      <path d="M8.211 2.047a.5.5 0 0 0-.422 0l-7.5 3.5a.5.5 0 0 0 .025.917l7.5 3a.5.5 0 0 0 .372 0L14 7.14V13a1 1 0 0 0-1 1v2h3v-2a1 1 0 0 0-1-1V6.739l.686-.275a.5.5 0 0 0 .025-.917z" />
                      <path d="M4.176 9.032a.5.5 0 0 0-.656.327l-.5 1.7a.5.5 0 0 0 .294.605l4.5 1.8a.5.5 0 0 0 .372 0l4.5-1.8a.5.5 0 0 0 .294-.605l-.5-1.7a.5.5 0 0 0-.656-.327L8 10.466z" />
                    </svg>
                  </div>
                  <div>
                    <p style={{ margin: '0px' }}><strong>Degree:</strong> Master of Application</p>
                    <p style={{ margin: '0px' }}><strong>University:</strong> MBM University</p>
                    <p style={{ margin: '0px' }}><strong>GPA:</strong> A+</p>
                    <p style={{ margin: '0px' }}><strong>Session: </strong> 2018-2020</p>
                  </div>
                </div>
              ))}
            </div>
          )
        }
        {
          (perview || activeTab === "experience") && experiences && (
            <div className="portfolio-section" style={{ marginBottom: 0 }}>
              {perview && <h3 style={{ textAlign: 'left', marginBottom: '10px', borderTop: '1px solid #ccc', paddingTop: '15px' }}>Experience</h3>}
              {experiences && experiences.map((experience, index) => (
                <div style={{ display: 'flex', gap: 15 }}>
                  <div>
                    <p style={{ margin: '0px', fontSize: '20px' }}>{experience.experience.position}({experience.experience.start} - {experience.experience.end})</p>
                    <p style={{ margin: '0px' }}><strong>Company:</strong> {experience.experience.company}, {experience.experience.location}</p>
                    {
                      experience.experience.presentJob && <p style={{ margin: '0px' }}><strong>Present Job:</strong> {experience.experience.presentJob ? 'Yes' : 'No'}</p>
                    }
                    <p style={{ margin: '0px' }}><strong>Description:</strong> {experience.experience.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          )
        }
        {
          (perview || activeTab === "projects") && projects && (
            <div className="portfolio-section" style={{ marginBottom: 0 }}>
              {perview && <h3 style={{ textAlign: 'left', marginBottom: '10px', borderTop: '1px solid #ccc', paddingTop: '15px' }}>Projects</h3>}
              {projects && projects.map((project, index) => (
                <div style={{ display: 'flex', gap: 15 }}>
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" fill="currentColor" class="bi bi-kanban" viewBox="0 0 16 16">
                      <path d="M13.5 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zm-11-1a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
                      <path d="M6.5 3a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1zm-4 0a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1zm8 0a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1z" />
                    </svg>
                  </div>
                  <div>
                    <p style={{ margin: '0px', fontSize: '30px' }}>{project.project.title}</p>
                    <p style={{ margin: '0px' }}>{project.project.description}</p>
                    <p style={{ margin: '0px' }}><strong>Role:</strong> {project.project.role}</p>
                    <p style={{ margin: '0px' }}><strong>Link:</strong> <a href={project.project.link} target="_blank" rel="noopener noreferrer">{project.project.link}</a></p>
                  </div>
                </div>
              ))}
            </div>
          )
        }
        {
          (perview || activeTab === "certifications") && certifications && (
            <div className="portfolio-section" style={{ marginBottom: 0 }}>
              {perview && <h3 style={{ textAlign: 'left', marginBottom: '10px', borderTop: '1px solid #ccc', paddingTop: '15px' }}>Certifications</h3>}
              {certifications && certifications.map((certificate, index) => (
                <div style={{ display: 'flex', gap: 15 }} key={index}>
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-award-fill" viewBox="0 0 16 16">
                      <path d="m8 0 1.669.864 1.858.282.842 1.68 1.337 1.32L13.4 6l.306 1.854-1.337 1.32-.842 1.68-1.858.282L8 12l-1.669-.864-1.858-.282-.842-1.68-1.337-1.32L2.6 6l-.306-1.854 1.337-1.32.842-1.68L6.331.864z" />
                      <path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1z" />
                    </svg>
                  </div>
                  <div>
                    <p style={{ margin: '0px' }}><strong>Award:</strong> {certificate.certification.name}</p>
                    <p style={{ margin: '0px' }}><strong>Organization:</strong> {certificate.certification.organization}</p>
                    <p style={{ margin: '0px' }}><strong>Issue Date:</strong> {certificate.certification.issue_date}</p>
                  </div>
                </div>
              ))}
            </div>
          )
        }
        {
          (perview || activeTab === "skills") && skills && (
            <div className="portfolio-section" style={{ marginBottom: 0 }}>
              {perview && <h3 style={{ textAlign: 'left', marginBottom: '10px', borderTop: '1px solid #ccc', paddingTop: '15px' }}>Skills</h3>}
              <div style={{ display: 'flex', gap: 6 }}>
                {skills && skills.map((skill, index) => (
                  // create cips for each skill
                  <div key={index} style={{ padding: '5px 10px', backgroundColor: 'lightgray', borderRadius: '5px' }}>
                    {skill.skill.skill}
                  </div>
                ))}
              </div>
            </div>
          )
        }
        {
          (perview || activeTab === "awards") && awards && (
            <div className="portfolio-section" style={{ marginBottom: 0 }}>
              {perview && <h3 style={{ textAlign: 'left', marginBottom: '10px', borderTop: '1px solid #ccc', paddingTop: '15px' }}>Awards</h3>}
              {awards && awards.map((award, index) => (
                <div style={{ display: 'flex', gap: 15 }} key={index}>
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" fill="currentColor" class="bi bi-award-fill" viewBox="0 0 16 16">
                      <path d="m8 0 1.669.864 1.858.282.842 1.68 1.337 1.32L13.4 6l.306 1.854-1.337 1.32-.842 1.68-1.858.282L8 12l-1.669-.864-1.858-.282-.842-1.68-1.337-1.32L2.6 6l-.306-1.854 1.337-1.32.842-1.68L6.331.864z" />
                      <path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1z" />
                    </svg>
                  </div>
                  <div>
                    <p style={{ margin: '0px' }}><strong>Award:</strong> {award.award.award}</p>
                    <p style={{ margin: '0px' }}><strong>Organization:</strong> {award.award.organization}</p>
                    <p style={{ margin: '0px' }}><strong>Year:</strong> {award.award.year}</p>
                  </div>
                </div>
              ))}
            </div>
          )
        }
        {
          (perview || activeTab === "interests") && interests && (
            <div className="portfolio-section" style={{ marginBottom: 0 }}>
              {perview && <h3 style={{ textAlign: 'left', marginBottom: '10px', borderTop: '1px solid #ccc', paddingTop: '15px' }}>Interests</h3>}
              <div style={{ display: 'flex', gap: 6 }}>
                {interests && interests.map((interest, index) => (
                  // create cips for each skill
                  <div key={index} style={{ padding: '5px 10px', backgroundColor: 'lightgray', borderRadius: '5px' }}>
                    {interest.interest.interest}
                  </div>
                ))}
              </div>
            </div>
          )
        }
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  educations: state.educations,
  experiences: state.experiences,
  skills: state.skills,
  interests: state.interests,
  awards: state.awards,
  projects: state.projects, // New
  certifications: state.certification, // New
  languages: state.languages, // New
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Portfolio);
